import { BundleProps } from 'utils/types';
import { EGradientDirection } from 'utils/enums';
import { CashFrenzyTemplate } from 'templates/Shared/CashFrenzy';

export const CashFrenzyBundle: React.FC<BundleProps> = ({
  prices,
  productList,
  backgroundSrc,
  backgroundColor = {
    colorOne: '#406cf9',
    colorTwo: '#6449ff',
    gradientDirection: EGradientDirection.TopToBottom,
  },
  badges = [],
  emblemBadges = [],
  salePercentage = 0,
  salePercentageDisplayType,
  inMobileMock,
  buttonSuffixImage,
  buttonSuffixAnimation,
}) => {
  return (
    <CashFrenzyTemplate
      prices={prices}
      productList={productList}
      backgroundSrc={backgroundSrc}
      backgroundColor={backgroundColor}
      emblemBadges={emblemBadges}
      badges={badges}
      salePercentage={salePercentage}
      salePercentageDisplayType={salePercentageDisplayType}
      inMobileMock={inMobileMock}
      buttonSuffixImage={buttonSuffixImage}
      buttonSuffixAnimation={buttonSuffixAnimation}
    />
  );
};
